/**
 * Enum for different column types
 */
export enum ColumnType {
  PLAIN = 'plain',
  DATE = 'date',
  TEMPLATE = 'template'
}

/**
 * Sort direction
 */
export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

/**
 * Sort state for a column
 */
export interface SortState {
  columnName: string;
  direction: SortDirection;
}

/**
 * Filter option for enum-based filtering
 */
export interface FilterOption {
  value: string;
  label: string;
}

/**
 * Configuration for a table column
 */
export interface ColumnConfig<T> {
  name: string;
  columnType: ColumnType;
  headerLabel: string;
  cellContent?: (rowData: T) => string | number | null | Date;
  cellTemplate?: () => any;
  template?: any;
  width?: string;
  sortable?: boolean;
  filterable?: boolean;
  filterOptions?: FilterOption[];
}

/**
 * Pagination configuration
 */
export interface PaginationState {
  pageIndex: number;
  pageSize: number;
  totalItems: number;
}
